import { useEffect, useState } from "react";

/** How Kiosk/Location/Product identity filters render in the filter bar. */
export type FilterDisplay = "compact" | "inline" | "palette";

const STORAGE_KEY = "webadmincc-filter-display";
const EVT = "webadmincc-filter-display-changed";

export function getFilterDisplay(): FilterDisplay {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "compact" || raw === "inline" || raw === "palette") return raw;
  } catch { /* noop */ }
  return "compact";
}

export function setFilterDisplay(mode: FilterDisplay): void {
  try { localStorage.setItem(STORAGE_KEY, mode); } catch { /* noop */ }
  window.dispatchEvent(new Event(EVT));
}

export function useFilterDisplay(): [FilterDisplay, (m: FilterDisplay) => void] {
  const [mode, setMode] = useState<FilterDisplay>(getFilterDisplay);

  useEffect(() => {
    function onChange() { setMode(getFilterDisplay()); }
    window.addEventListener(EVT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(EVT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  return [mode, setFilterDisplay];
}
